export default "__VITE_ASSET__yferQDPC__"